import React from 'react';
import LikeSvg from '@catalogo/ui-americanas-desktop-svg/like-v2.svg';
import withFeedbackReview from '@catalogo/service-americanas-product-review/src/hocs/withFeedbackReview';
import { LikeDislikeProps } from '../../../types';
import {
  ActionRecommendation,
  ContainerFeedback,
  Flex,
  LabelRecommendation,
  Like,
  RecommendationText,
  Unlike,
} from './Styled';

const Comp: React.FC<LikeDislikeProps> = props => {
  const { positiveFeedback, negativeFeedback, like, handleFeedback, dislike, id } = props;
  const handleLike = () => handleFeedback('upvote', id);
  const handleDislike = () => handleFeedback('downvote', id);
  const likeCount = like ? 1 + positiveFeedback : positiveFeedback;
  const dislikeCount = dislike ? 1 + negativeFeedback : negativeFeedback;

  return (
    <ContainerFeedback>
      <RecommendationText>essa avaliação foi útil?</RecommendationText>
      <Flex>
        <ActionRecommendation aria-label="curtir" onClick={handleLike}>
          <Like userFeedback={like}>
            <LikeSvg />
          </Like>
          <LabelRecommendation>({likeCount})</LabelRecommendation>
        </ActionRecommendation>
        <ActionRecommendation aria-label="descurtir" onClick={handleDislike}>
          <Unlike userFeedback={dislike}>
            <LikeSvg />
          </Unlike>
          <LabelRecommendation>({dislikeCount})</LabelRecommendation>
        </ActionRecommendation>
      </Flex>
    </ContainerFeedback>
  );
};

const LikeDislike = withFeedbackReview(Comp);
const LikeDislikeComp = Comp;

export default LikeDislike;
export { LikeDislike, LikeDislikeComp };
